/* eslint-disable max-len */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { string } from 'prop-types';

const Info = (props) => (
  <SvgIcon
    style={{
      width: '14px',
      height: '14px',
    }}
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{props.title}</title>
    <defs>
      <path
        d="M8,14.5454545 C4.38501818,14.5454545 1.45454545,11.6152727 1.45454545,8 C1.45454545, 4.38472727 4.38501818,1.45454545 8,1.45454545 C11.6149818,1.45454545 14.5454545, 4.38472727 14.5454545,8 C14.5454545,11.6152727 11.6149818,14.5454545 8,14.5454545 Z M8, 13.0909091 C10.8116364,13.0909091 13.0909091,10.8116364 13.0909091,8 C13.0909091, 5.18836364 10.8116364,2.90909091 8,2.90909091 C5.18836364,2.90909091 2.90909091, 5.18836364 2.90909091,8 C2.90909091,10.8116364 5.18836364,13.0909091 8,13.0909091 Z M8.72727273, 10.9090909 C8.72727273,11.3105455 8.40167273,11.6363636 8,11.6363636 C7.59832727, 11.6363636 7.27272727,11.3105455 7.27272727,10.9090909 L7.27272727,7.27272727 C7.27272727, 6.87127273 7.59832727,6.54545455 8,6.54545455 C8.40167273,6.54545455 8.72727273, 6.87127273 8.72727273,7.27272727 L8.72727273,10.9090909 Z M7.27272727,5.09090909 C7.27272727, 4.68945455 7.59832727,4.36363636 8,4.36363636 C8.40167273,4.36363636 8.72727273, 4.68945455 8.72727273,5.09090909 C8.72727273,5.49236364 8.40167273,5.81818182 8, 5.81818182 C7.59832727,5.81818182 7.27272727,5.49236364 7.27272727,5.09090909 Z"
        id="path-1-info"
      />
    </defs>
    <g id="Registration-UI" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="6.41---Personal-details---Filled---Desktop-HD"
        transform="translate(-640.000000, -759.000000)"
      >
        <g id="Icon-Copy" transform="translate(639.000000, 758.000000)">
          <mask id="mask-2" fill="white">
            <use xlinkHref="#path-1-info" />
          </mask>
          <use id="Icon" fill={props.fill} xlinkHref="#path-1-info" />
        </g>
      </g>
    </g>
  </SvgIcon>
);

Info.propTypes = {
  title: string,
  fill: string,
};

Info.defaultProps = {
  title: '',
  fill: '#185078',
};

export default Info;
